<template>
  <div class="flex-column" style="background-color: white;overflow: hidden">
    <top-bar :title="'青年榜样'" :show-back="true"></top-bar>
    <div class="main-content-t2_4 flex-column justify-content-start align-items-center w100"
         style="padding: 10px">
      <div class="back-image qingyun-item w100 mt02"
           v-for="(item,index) of imgsArr" :key="index"
           style="border-bottom-right-radius: 0.2rem"
           :style="{ backgroundImage: 'url('+ item.src +')'}">
        <div class="w100 flex-row justify-content-start align-items-center label"
             style="height: 2.18rem;padding-left: 0.2rem;color: whitesmoke;font-weight: 600;font-size: 0.4rem">
          <i class="w100">{{ item.info }}</i>
          <div class="flex-column justify-content-end align-items-center "
               style="height: 100%;font-size: 0.2rem;width: 1rem">
            <div class="ribbon">
              <div class="ribbon1">开发中</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import topBar from "../top-bar/index2";

export default {
  name: "waterfall",
  components: {
    topBar
  },
  data() {
    return {
      route: {},
      imgsArr: [
        {
          src: require("@assets/home_new/qingyun/qingyun1.png"),
          // href: " /test",
          info: "两红两优",
          route: undefined
        },
        {
          src: require("@assets/home_new/qingyun/qingyun2.png"),
          // href: " /test",
          info: "五四奖章",
          route: undefined
        },
        {
          src: require("@assets/home_new/qingyun/qingyun3.png"),
          href: " /test",
          info: "向上向善",
          route: undefined
        },
        {
          src: require("@assets/home_new/qingyun/qingyun4.png"),
          href: " /test",
          info: "少先队",
          route: undefined
        },
        {
          src: require("@assets/home_new/qingyun/qingyun5.png"),
          info: "少先队辅导员",
          route: undefined
        },
        {
          src: require("@assets/home_new/qingyun/qingyun6.png"),
          username: undefined,
          info: "母亲河奖",
          route: undefined
        },
        {
          src: require("@assets/home_new/qingyun/qingyun7.png"),
          username: undefined,
          info: "网上好青年",
          route: undefined
        },
        {
          src: require("@assets/home_new/qingyun/qingyun8.png"),
          username: undefined,
          info: "青少年维权",
          route: undefined
        },
        {
          src: require("@assets/home_new/qingyun/qingyun9.png"),
          username: undefined,
          info: "青少志愿者",
          route: undefined
        },
        {
          src: require("@assets/home_new/qingyun/qingyun10.png"),
          username: undefined,
          info: "青少文明号",
          route: undefined
        }
      ]
    };
  },
  created() {
    this.route = this.$route.query;
  },
  mounted() {
  },
  destroyed() {
  },
  methods: {}
};
</script>

<style scoped>
@import "../../assets/css/flex.css";
@import "../../assets/css/font-title.css";
@import "../../assets/css/msg.css";

.qingyun-item {
}

.ribbon {
  width: 1rem;
  height: 1rem;
  overflow: hidden;
  top: -6px;
  left: -6px;
}

.ribbon1 {
  line-height: 18px;
  text-align: center;
  transform: rotate(315deg);
  position: relative;
  left: 0.14rem;
  top: 26px;
  width: 1.5rem;
  height: 0.7rem;
  background: goldenrod;
  color: white;
  box-shadow: 0 5px 5px rgba(0, 0, 0, 0.1);
  letter-spacing: 1px;
}

.ribbon1:before,
.ribbon1:after {
  content: "";
  border-top: 4px solid #4e7c7d;
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  position: absolute;
  bottom: -4px;
}

.ribbon1:before {
  left: 0;
}

.ribbon1:after {
  right: 0;
}
</style>
